<template>
  <div class="dashboard">
      <div class="row text-center">
        <div class="col-12 col-md-6">
          <!-- links -->
          <div class="row">
            <div class="col-12 mb-4">
                <div class="d-flex justify-content-center" style="margin-bottom: -30px;">
                    <div
                        class="thumbnail d-flex justify-content-center align-items-center"
                        style="background-color: #dedee7; border: 3px solid white;"
                    >
                        <icon name="birthday"></icon>
                    </div>
                </div>
                <div style="background: white; padding: 20px; padding-top: 40px">
                    <div v-if="birthdays && birthdays.length > 0" style="text-align: left">
                      <child-list type="birthdays" :filteredChildren="birthdays"></child-list>
                    </div>
                    <div v-else>
                      Voorlopig geen verjaardagen
                    </div>
                </div>
            </div>
            <div v-if="getApplicationSetting('ipad_dashboard_announcements') === '1'" class="col-12 mb-4">
              <h3>Mededelingen</h3>
              <div style="background: white; padding: 20px; padding-top: 40px">
                <div v-if="announcements && announcements.length > 0" style="text-align: left">
                  <div v-for="announcement in announcements" :key="announcement.id">
                    <p>
                      <b>
                        <span v-if="isCurrentYear(announcement.date)">
                          {{ this.$moment(announcement.date).format('dd D MMMM') }}
                        </span>
                        <span v-else>
                          {{ this.$moment(announcement.date).format('dd D MMMM YYYY') }}
                        </span>
                      </b>
                      <br>
                      <span style="white-space: pre-line">{{announcement.note}}</span>
                    </p>
                    <hr>
                  </div>
                    <router-link to="/transfer/messages?type=sticky">
                        Meer
                    </router-link>
                </div>
                <div v-else>
                  Geen mededelingen
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <!-- rechts -->
          <div class="row">
            <div v-if="getApplicationSetting('child_tracking_system') === '1'" class="col-12 mb-4">
              <div class="d-flex justify-content-center" style="margin-bottom: -30px;">
                  <div
                      class="thumbnail d-flex justify-content-center align-items-center"
                      style="background-color: #dedee7; border: 3px solid white;"
                  >
                      <icon name="reminder"></icon>
                  </div>
              </div>
              <div style="background: white; padding: 20px; padding-top: 40px">
                <div v-if="triggers.length > 0" style="text-align: left">
                  <table class="table">
                    <thead>
                    <tr>
                      <th>Kind naam</th>
                      <th> </th>
                      <th>Datum herinnering</th>
                      <th style="width:150px;">Omschrijving</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(trigger, key) in triggers" v-bind:key="key">
                      <td>
                        <router-link :to="'/childtrackingsystem/editobservationlist/' + trigger.idResult">{{key+1}}. {{ trigger.childName }}</router-link></td>
                      <td>
                        <span v-if="trigger.error !==''" style="color:#dc3545">
                          <icon name="reminder"></icon>
                        </span>
                      </td>
                      <td>{{ trigger.dateTrigger }}</td>
                      <td>{{ trigger.description }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <div v-else>
                  Voorlopig geen herinneringen
                </div>
              </div>
            </div>
            <div v-if="getApplicationSetting('ipad_dashboard_mutations') === '1'" class="col-12 mb-4">
                <div class="d-flex justify-content-center" style="margin-bottom: -30px;">
                    <div
                        class="thumbnail d-flex justify-content-center align-items-center"
                        style="background-color: #dedee7; border: 3px solid white;"
                    >
                        <icon name="planning-edit"></icon>
                    </div>
                </div>
                <div style="background: white; padding: 20px; padding-top: 40px">
                    <div v-if="mutations && mutations.length > 0" style="text-align: left">
                      <child-list type="mutations" :filteredChildren="mutations"></child-list>
                    </div>
                    <div v-else>
                      Voorlopig geen wijzigingen
                    </div>
                </div>
            </div>
            <div v-if="getApplicationSetting('ipad_dashboard_transfer_notes') === '1'" class="col-12 mb-4">
              <h3>Overdracht</h3>
              <div style="background: white; padding: 20px; padding-top: 40px">
                <div v-if="transferNotes && transferNotes.length > 0" style="text-align: left">
                  <div v-for="transferNote in transferNotes" :key="transferNote.id">
                    <p>
                      <b>
                        <span v-if="isCurrentYear(transferNote.date)">
                          {{ this.$moment(transferNote.date).format('dd D MMMM') }}
                        </span>
                        <span v-else>
                          {{ this.$moment(transferNote.date).format('dd D MMMM YYYY') }}
                        </span>
                      </b>
                      <br>
                      <span style="white-space: pre-line">{{transferNote.note}}</span>
                    </p>
                    <hr>
                  </div>
                  <router-link to="/transfer/messages?type=nonSticky">
                      Meer
                  </router-link>
                </div>
                <div v-else>
                  Geen overdrachten
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import ChildList from '@/components/Child-List'
import Icon from "@/components/Icon.vue";
export default {
  name: 'dashboard',
  components: {
      Icon,
    ChildList
  },
  data() {
    return {
      triggers: []
    }
  },
  computed: {
    birthdays () {
      return this.$store.getters.birthdays
    },
    mutations () {
      return this.$store.getters.mutations
    },
    allNotes () {
      return this.$store.getters.transferNotes
    },
    announcements () {
      let notes = this.$store.getters.transferNotes || []
      if (notes.length < 1) {
        return notes
      }
      notes = notes.filter(el => {
        return el.sticky === true
      })
      notes = notes.slice(0, 3).map(el => {
          return el
      })
      return notes
    },
    transferNotes () {
      let notes = this.$store.getters.transferNotes || []
      if (notes.length < 1) {
        return notes
      }
      notes = notes.filter(el => {
        return el.sticky === false
      })
      notes = notes.slice(0, 3).map(el => {
          return el
      })
      return notes
    }
  },
  created () {
    this.$store.dispatch('getBirthdays')
    this.$store.dispatch('getMutations')
    this.$store.dispatch('getTransferNotes', {date: this.$moment().format('YYYY-MM-DD')})
    this.getTriggers()
  },
  methods: {
    isCurrentYear (date) {
      if (this.$moment(date).format('YYYY') == this.$moment().format('YYYY')) {
        return true;
      }
      return false;
    },
    getTriggers () {
      this.$request.post('/ChildTrackingSystem/triggers', {
        idEstablishment: this.$store.getters.selectedEstablishment.id,
        idGroup: this.$store.getters.selectedGroupsQueryString, // @todo Fix for all groups
        lastData: true
      }).then((response) => {
        if (response) {
          this.triggers = response.savedTriggers
        }
      })
    },
    goToReminder() {
      this.$router.push('/childtrackingsystem/triggers')
    }
  }
}
</script>

<style scoped>
.col-sm-6 {
  margin-bottom: 20px;
  text-align: center;
}

.thumbnail {
    position: relative;
    top: 0;
    left: 0;
    width: 66px;
    height: 66px;
    border-radius: 50%;
    background-repeat: no-repeat !important;
    background-attachment: fixed;
    background-position: center;
    background-size: cover !important;
}

</style>
